import React from 'react'
import styles from './bulk-action-bar.styles'
import ContentHolder from '../content-holder/content-holder'
import Button from 'pobble-components/dist/button'
import injectSheet from 'react-jss'
import EllipsisIcon from 'react-icons/lib/fa/ellipsis-h'
import DropMenu from 'pobble-components/dist/drop-menu'
import classNames from 'classnames'

const BulkActionBar = ({
  show,
  classes,
  renderContextMenu,
  selected = [],
  onShowSelected,
  showingSelected,
  onShowAll,
  renderMessage = () => null
}) => {
  return (
    <div className={classNames(classes.container, { [classes.show]: show })}>
      <ContentHolder className={classes.contentHolder}>
        <div>
          <span className={classes.selected}>{renderMessage(selected)}</span>
          {!showingSelected && (
            <span className={classes.showSelected} onClick={onShowSelected}>
              Show selected
            </span>
          )}
          {showingSelected && (
            <span className={classes.showSelected} onClick={onShowAll}>
              Show all
            </span>
          )}
        </div>
        <div>
          <DropMenu
            button={({ ref, togglePopover }) => (
              <Button nodeRef={ref} action={togglePopover} tall>
                <EllipsisIcon className={classes.buttonIcon} />
                Action
              </Button>
            )}>
            {renderContextMenu
              ? renderContextMenu
              : () => 'Supply context menu please'}
          </DropMenu>
        </div>
      </ContentHolder>
    </div>
  )
}

export default injectSheet(styles)(BulkActionBar)
